module.exports = __webpack_public_path__ + "static/media/ok_logo.a0a2c3c9.png";